const DEFAULT_TEMPLATE_HEADINGS = [
  'Banker First Name',
  'Banker Last Name',
  'Banker Email',
  'BankerMapID',
  'BankerTeam',
  'Customer First Name',
  'Customer Last Name',
  'CustomerMapID',
  'Customer Email',
  'Customer Group',
  'Date Added',
  'Customer Phone',
];

const SMS_CUSTOMER_TEMPLATE_HEADINGS = [
  'Customer First Name',
  'Customer Last Name',
  'Customer Email',
  'Customer Group',
  'Date Added',
  'Customer Phone',
];

const CUSTOMER_TEMPLATE_HEADINGS = [
  'Customer First Name',
  'Customer Last Name',
  'CustomerMapID',
  'Customer Email',
  'Customer Group',
  'Date Added',
  'Customer Phone',
];

const CUSTOMER_NOTES_TEMPLATE_HEADINGS = [
  'CustomerMapID',
  'Note',
  'Type',
  'expiration_date',
  'display_frequency',
];

const OUTBOUND_SMS_TEMPLATE_HEADINGS = [
  'first_name',
  'last_name',
  'phone',
  'email',
];

const WEBCHAT_TEMPLATE_HEADINGS = [
  'ID',
];

const SMS_TEMPLATE_HEADING = [
  'phone',
];

const CUSTOMER_CELEBRATION_TEMPLATE_HEADINGS = [
  'ID',
  'type',
  'date',
];

const CUSTOMER_CAMPAIGN_HEADER = [
  'ID',
  'campaign',
  'phone',
  'start_date',
];

const CUSTOMER_CAMPAIGN_TERMINATE_HEADER = [
  'ID',
  'phone',
  'campaign',
];

const AGENT_CAMPAIGN_HEADER = [
  'email',
  'campaign',
  'start_date',
];

const AGENT_CAMPAIGN_TERMINATE_HEADER = [
  'email',
  'campaign',
];

const INGESTION_MODES = [
  {
    key: 'default',
    label: 'Relationships',
    endpoint: '/users',
    headings: DEFAULT_TEMPLATE_HEADINGS,
    isDefault: true,
    overridable: true,
  },
  {
    key: 'sms-customers',
    label: 'Anonymous SMS Conversations',
    endpoint: '/customers',
    headings: SMS_CUSTOMER_TEMPLATE_HEADINGS,
    isDefault: false,
    channel: 'sms',
    overridable: true,
  },
  {
    key: 'customers-celebration',
    label: 'Celebration Conversations',
    endpoint: '/customers/celebration',
    headings: CUSTOMER_CELEBRATION_TEMPLATE_HEADINGS,
    isDefault: false,
    overridable: false,
  },

  {
    key: 'customers',
    label: 'Authenticated Conversations',
    endpoint: '/customers',
    headings: CUSTOMER_TEMPLATE_HEADINGS,
    isDefault: false,
    channel: 'webchat',
    overridable: true,
  },
  {
    key: 'customers_notes',
    label: 'Conversation Notes',
    endpoint: '/customers/notes',
    headings: CUSTOMER_NOTES_TEMPLATE_HEADINGS,
    isDefault: false,
    overridable: false,
  },
  {
    key: 'template-sms-sending',
    label: 'Outbound SMS - template',
    endpoint: '/sms',
    headings: OUTBOUND_SMS_TEMPLATE_HEADINGS,
    isDefault: false,
    overridable: false,
  },
  {
    key: 'customer-campaign',
    label: 'Campaign',
    endpoint: '/customers/campaign',
    headings: CUSTOMER_CAMPAIGN_HEADER,
    isDefault: false,
    overridable: false,
  },
  {
    key: 'customer-campaign-terminate',
    label: 'Stop Campaign',
    endpoint: '/customers/campaign/terminate',
    headings: CUSTOMER_CAMPAIGN_TERMINATE_HEADER,
    isDefault: false,
    overridable: false,
  },
  {
    key: 'agent-campaign',
    label: 'Agent Campaign',
    endpoint: '/agents/campaign',
    headings: AGENT_CAMPAIGN_HEADER,
    isDefault: false,
    overridable: false,
  },
  {
    key: 'agent-campaign-terminate',
    label: 'Stop Agent Campaign',
    endpoint: '/agents/campaign/terminate',
    headings: AGENT_CAMPAIGN_TERMINATE_HEADER,
    isDefault: false,
    overridable: false,
  },
];

export {
  DEFAULT_TEMPLATE_HEADINGS,
  CUSTOMER_NOTES_TEMPLATE_HEADINGS,
  WEBCHAT_TEMPLATE_HEADINGS,
  OUTBOUND_SMS_TEMPLATE_HEADINGS,
  INGESTION_MODES,
  SMS_TEMPLATE_HEADING,
};
